var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.5 10.5C9.5 9.67157 8.82843 9 8 9C7.17157 9 6.5 9.67157 6.5 10.5C6.5 11.3284 7.17157 12 8 12C8.82843 12 9.5 11.3284 9.5 10.5ZM16 9C16.8284 9 17.5 9.67157 17.5 10.5C17.5 11.3284 16.8284 12 16 12C15.1716 12 14.5 11.3284 14.5 10.5C14.5 9.67157 15.1716 9 16 9ZM8.24742 14.3356C7.8805 13.9229 7.24843 13.8857 6.83565 14.2526C6.42286 14.6195 6.38568 15.2516 6.7526 15.6644C7.54154 16.5519 8.98683 17.5924 10.8365 17.899C12.7413 18.2148 14.9596 17.7318 17.169 15.7433C17.5795 15.3738 17.6128 14.7415 17.2433 14.331C16.8738 13.9205 16.2416 13.8872 15.831 14.2567C14.0405 15.8682 12.4254 16.1352 11.1636 15.926C9.84653 15.7076 8.79182 14.9481 8.24742 14.3356Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.381964039ce0f80d1eb0430244e500a6.svg";
export { ForwardRef as ReactComponent };